import { Form, Modal, message } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { supplierUpdateFieldTechLocations } from '../../thunks/supplier_contacts_thunks';
import SupplierRegionsLocationsTreeSelect from '../regions_tree_select/SupplierRegionsLocationsTreeSelect';
import SelectWithAllToggle from '../common/SelectWithAllToggle';

const EditAccessibleLocationsModal: FC<any> = ({
	onCancel,
	onSuccess,
	email,
	hasAccessToAllLocations: initialHasAccessToAllLocations,
	locationIds: initialLocationIds,
	updateFieldTechLocations,
}): React.ReactElement => {
	const [form] = Form.useForm();
	const [updating, setUpdating] = useState(false);

	const handleSubmit = useCallback(
		(values) => {
			const hasAccessToAllLocations = !!values.hasAccessToAllLocations;
			setUpdating(true);
			updateFieldTechLocations({
				userId: email,
				hasAccessToAllLocations,
				locationIds: hasAccessToAllLocations ? [] : nullSafeGetOrElse('locationIds', values, []),
			})
				.then(() => onSuccess && onSuccess())
				.catch(() => message.error('Unable to update accessible locations.'))
				.finally(() => setUpdating(false));
		},
		[email, onSuccess, updateFieldTechLocations]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={'Edit Accessible Locations'}
			okText={'Save'}
			onCancel={onCancel}
			onOk={form.submit}
			closable={true}
			confirmLoading={updating}
			destroyOnClose={true}
		>
			<Form
				form={form}
				layout="vertical"
				className="supplierForm"
				preserve={false}
				initialValues={{
					hasAccessToAllLocations: !!initialHasAccessToAllLocations,
					locationIds: initialLocationIds || [],
				}}
				onFinish={handleSubmit}
			>
				<SelectWithAllToggle
					label={'Locations'}
					name={'locationIds'}
					allName={'hasAccessToAllLocations'}
					form={form}
					selectAllPlaceholder={'All locations'}
				>
					<SupplierRegionsLocationsTreeSelect
						mode="multiple"
						targetCollectionName={'fieldTechAccessibleLocations'}
					/>
				</SelectWithAllToggle>
			</Form>
		</Modal>
	);
};

const mapDispatchToProps = (dispatch) => ({
	updateFieldTechLocations: (payload) => dispatch(supplierUpdateFieldTechLocations(payload)),
});

export default connect(null, mapDispatchToProps)(EditAccessibleLocationsModal);
